import React from 'react';
import {JsonEditorProvider, useJsonEditor} from './JsonEditorContext';
import {TreeProvider, useTree} from './TreeContext';
import {CircuitFormProvider, useCircuitForm} from './CircuitFormContext';

/**
 * Backward-compatible DataProvider — composes the three focused providers.
 * Existing consumers can keep using `useData()` which merges all three contexts.
 *
 * New code should prefer importing the specific hook:
 *   useJsonEditor, useTree, useCircuitForm
 */
export const DataProvider = ({children}) => (
  <JsonEditorProvider>
    <TreeProvider>
      <CircuitFormProvider>
        {children}
      </CircuitFormProvider>
    </TreeProvider>
  </JsonEditorProvider>
);

/**
 * Legacy hook — merges all three contexts into one object.
 * Prefer the granular hooks in new code.
 */
export const useData = () => {
  const jsonEditor = useJsonEditor();
  const tree = useTree();
  const circuitForm = useCircuitForm();
  return {...jsonEditor, ...tree, ...circuitForm};
};
